/**
 * <navera-recently-viewed>: stores viewed product handles in localStorage and renders them as
 * tiles fetched from sections/navera-product-tile.liquid (Section Rendering API), so prices and
 * badges are formatted by Shopify. Stays hidden when there is nothing to show.
 */
const STORAGE_KEY = 'navera:recently-viewed';
const MAX_STORED = 12;

function readHandles() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.filter((h) => typeof h === 'string') : [];
  } catch {
    return [];
  }
}

function writeHandles(handles) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
  } catch {
    /* storage unavailable (private mode): the section simply stays hidden */
  }
}

class NaveraRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.current || '';
    const limit = Number(this.dataset.limit || 5);
    const root = this.dataset.root || '';
    const stored = readHandles();

    if (current) {
      writeHandles([current, ...stored.filter((h) => h !== current)]);
    }

    const handles = stored.filter((h) => h !== current).slice(0, limit);
    if (!handles.length) return;

    this.#render(handles, root);
  }

  async #render(handles, root) {
    const list = this.querySelector('[data-recent-list]');
    if (!list) return;

    const results = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=navera-product-tile`);
          if (!response.ok) return null;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.nv-tile');
        } catch {
          return null;
        }
      })
    );

    const tiles = results.filter(Boolean);
    // Forget products that no longer exist.
    if (tiles.length !== handles.length) {
      const alive = new Set(tiles.map((tile) => tile.dataset.productHandle));
      writeHandles(readHandles().filter((h) => !handles.includes(h) || alive.has(h)));
    }
    if (!tiles.length) return;

    list.replaceChildren(...tiles);
    this.hidden = false;
  }
}

if (!customElements.get('navera-recently-viewed')) {
  customElements.define('navera-recently-viewed', NaveraRecentlyViewed);
}
